<template>
  <div>
    <!--
    <div class="caption mb-4">
      <div>
        <span class="overline short grey--text mr-3">From</span>+1 (708) 866-0090
      </div>
      <div>
        <span class="overline short grey--text mr-3">To</span>{{recipient?.phone | phone}}
      </div>
    </div>
    -->

    <text-bubble class="text-left">
      <template v-slot:mms>
        <v-responsive
          class="relative"
          v-bind:style="{ 'background-color': order.skin.page_background_color }"
          :aspect-ratio="16 / 9"
        >
          <v-card class="absolute" style="z-index: 1; left: 17.1875%; top: 8.3333%; width: 65.625%;" tile>
            <v-responsive class="relative" :aspect-ratio="7 / 5">
              <v-responsive class="absolute overflow-visible" style="top: -20%; width: 100%;" :aspect-ratio="1">
                <envelope class="fill-height" :skin="order.skin" :from="from" :to="to" />
              </v-responsive>
            </v-responsive>
          </v-card>
          <v-img :src="img" />
        </v-responsive>
      </template>
      <div class="preserve-newlines" v-html="skin.email_subject" />
      <div v-if="toTxt">To:&nbsp;<span v-text="toTxt" /></div>
      <div v-if="fromTxt">From:&nbsp;<span v-text="fromTxt" /></div>
      <div v-if="followUpMsg">
        <br>
        <span class="preserve-newlines">{{followUpMsg}}</span>
      </div>
      <br>
      <div style="word-break: normal;">
        Follow this link to {{order.type == 'INVITATION' ? 'see more details and RSVP' : 'open the card'}}
      </div>
      <a class="white--text" style="text-decoration: underline;" @click="$emit('preview')">
        https://ellacard.com/open/{{orderId || '…'}}
      </a>
    </text-bubble>
  </div>
</template>

<script>
import Envelope from '@/components/Envelope.vue';
import TextBubble from '@/components/TextBubble.vue';
import stripHTML from '@/utils/strip-html.js';

export default {
  name: 'recipient-preview-text',

  components: {
    Envelope,
    TextBubble
  },

  props: {
    orderId: String, // Purely cosmetic, could be set to a placeholder
    order: Object,
    from: String,
    to: String,
    followUpMsg: String
  },

  computed: {
    skin() {
      return this.order.skin;
    },

    fromTxt() {
      return stripHTML(this.from);
    },

    toTxt() {
      return stripHTML(this.to);
    },

    img() {
      const src = this.skin.page_background_img;
      return (src || '').endsWith('.mp4') ? (src.slice(0, -4) + '.poster.jpg') : src;
    }
  }
}
</script>
